var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._l((_vm.resource.text),function(text,index){return _c('p',{key:index,staticClass:"mb-0 f-16",domProps:{"innerHTML":_vm._s(text)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }